"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRestFnNoParams = exports.useRestFn = void 0;
const tslib_1 = require("tslib");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const react_1 = tslib_1.__importDefault(require("react"));
function useRestFn(func) {
    const { makeJsonRestApiRequest } = (0, vizportalclient_common_components_1.useRestApiService)();
    const result = react_1.default.useCallback((params) => tslib_1.__awaiter(this, void 0, void 0, function* () { return func(Object.assign({ makeJsonRestApiRequest }, params)); }), [
        func,
        makeJsonRestApiRequest,
    ]);
    return result;
}
exports.useRestFn = useRestFn;
function useRestFnNoParams(func) {
    const { makeJsonRestApiRequest } = (0, vizportalclient_common_components_1.useRestApiService)();
    const result = react_1.default.useCallback(() => tslib_1.__awaiter(this, void 0, void 0, function* () { return func({ makeJsonRestApiRequest }); }), [func, makeJsonRestApiRequest]);
    return result;
}
exports.useRestFnNoParams = useRestFnNoParams;
//# sourceMappingURL=useRestFn.js.map